module.exports = __webpack_public_path__ + "static/media/menu-logo_2x.f3c19353.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/menu-logo_2x.png
// module id = 219
// module chunks = 0